/* Yarn First (Black Friday 2026): join form, countdowns, timed refresh, share,
   pack prefill, terms popup, sticky entry bar. Settings come from window.YF
   (snippets/yf-config.liquid). No dependencies. */
(function () {
  'use strict';
  var YF = window.YF || {};
  var K = YF.k || {};
  var ERR = YF.err || {};

  function now() { return Math.floor(Date.now() / 1000) + (YF.offset || 0); }

  // UTM parameters from the landing URL, kept for the visit so they go with the entry.
  var UTM = (function () {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var found = {};
    try {
      var q = new URLSearchParams(location.search);
      keys.forEach(function (k) { var v = q.get(k); if (v) found[k] = v.slice(0, 200); });
      if (Object.keys(found).length) { sessionStorage.setItem('yf_utm', JSON.stringify(found)); return found; }
      return JSON.parse(sessionStorage.getItem('yf_utm') || '{}');
    } catch (e) { return found; }
  })();
  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }

  /* ---------- Klaviyo (client API, public key only) ---------- */
  var testMode = !K.company || !K.list;
  // On the published theme (outside the editor) a missing list ID is an error, never a fake success.
  var liveBlocked = testMode && !!YF.live;

  function kPost(path, body) {
    if (liveBlocked) {
      if (window.console) console.error('[Yarn First] No Klaviyo list ID in Theme settings: entry not sent.');
      return Promise.reject(new Error('Klaviyo list ID missing'));
    }
    if (testMode) {
      if (window.console) console.info('[Yarn First test mode] would send', path, body);
      return Promise.resolve({ ok: true, test: true });
    }
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(K.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': K.rev },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + path + ' ' + r.status);
      return r;
    });
  }

  function subscribe(attrs, source) {
    return kPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Yarn First - ' + source,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: K.list } } }
      }
    });
  }

  function track(metric, email, props, profileProps, uniqueId) {
    if (!metric) return Promise.resolve();
    var profile = { email: email };
    if (profileProps) profile.properties = profileProps;
    var attributes = {
      metric: { data: { type: 'metric', attributes: { name: metric } } },
      profile: { data: { type: 'profile', attributes: profile } },
      properties: props
    };
    // Klaviyo keeps only the first event with the same unique_id, so a retry can't double-count.
    if (uniqueId) attributes.unique_id = uniqueId;
    return kPost('events', { data: { type: 'event', attributes: attributes } });
  }
  function newId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* old browser */ }
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2);
  }

  function toE164(raw) {
    var m = String(raw || '').replace(/[\s().-]/g, '');
    m = m.replace(/^0061/, '+61').replace(/^(\+?61)0(4\d{8})$/, '$1$2');
    if (/^04\d{8}$/.test(m)) return '+61' + m.slice(1);
    if (/^614\d{8}$/.test(m)) return '+' + m;
    if (/^\+614\d{8}$/.test(m)) return m;
    return null;
  }

  function publishLead(source) {
    if (testMode) return; // never send test entries to the ad accounts
    try {
      if (YF.lead && window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(YF.lead, { content_name: source });
      }
    } catch (e) { /* analytics must never break the form */ }
  }

  /* ---------- Join form ---------- */
  function initJoin(root) {
    if (root.__yf) return;
    root.__yf = true;
    var source = root.getAttribute('data-source') || 'bf-hub';
    var persona = root.getAttribute('data-persona') || '';
    var open = (root.getAttribute('data-open') || '').split(',').filter(Boolean);
    var steps = {};
    qsa(root, '[data-step]').forEach(function (el) { steps[el.getAttribute('data-step')] = el; });
    var dots = qsa(root, '.yf-dots i'); // none on the one-step form
    var state = { email: '', mobile: false, dirty: false };

    function show(key) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== key; });
      var n = key === 'done' ? dots.length : parseInt(key, 10);
      dots.forEach(function (d, i) { d.classList.toggle('on', i < n); });
      var f = key === 'done' ? steps.done : qs(steps[key], 'input,button');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }
    function busy(form, on) { qsa(form, 'button[type="submit"]').forEach(function (b) { b.disabled = on; }); }
    function err(form, msg, input) {
      var p = qs(form, '.yf-err');
      if (p) p.textContent = msg || '';
      qsa(form, '[aria-invalid]').forEach(function (i) { i.removeAttribute('aria-invalid'); });
      if (input && msg) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }
    function done() {
      var line = qs(steps.done, '[data-yf-done-line]');
      if (line) line.textContent = root.getAttribute('data-done-mobile') || '';
      show('done');
      document.dispatchEvent(new CustomEvent('yf:joined', { detail: { source: source } }));
    }

    root.addEventListener('input', function () { state.dirty = true; });

    var f1 = steps['1'];
    var picks = [];
    var entryId = newId();
    f1.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = qs(f1, 'input[name="email"]');
      var phone = qs(f1, 'input[name="phone"]');
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err(f1, ERR.email, input); return; }
      var e164 = toE164(phone ? phone.value : '');
      if (!e164) { err(f1, ERR.mobile, phone); return; }
      var box = qs(f1, 'input[name="consent"]');
      var boxLabel = box ? box.closest('.yf-consent') : null;
      if (boxLabel) boxLabel.classList.remove('is-invalid');
      if (box && !box.checked) { err(f1, ERR.consent, box); if (boxLabel) boxLabel.classList.add('is-invalid'); return; }
      err(f1, '');
      busy(f1, true);
      // The tick box wording exactly as shown is recorded with the entry, with the fact it was ticked.
      var wording = ((qs(f1, '[data-yf-consent-text]') || {}).textContent || '').replace(/\s+/g, ' ').trim();
      var record = {
        sms_consent: true,
        consent_ticked: !!(box && box.checked),
        sms_consented_at: new Date().toISOString(),
        sms_consent_source: source,
        sms_consent_text: wording,
        yf_mobile: e164
      };
      var props = Object.assign({ source: source }, record);
      if (persona) props.persona = persona;
      // Packs picked from the hub's tiles only count while the hub asks which packs (step 3 on).
      // With it off, a hub entry stays generic (no persona or pack_interest), so Klaviyo runs only
      // the hub flow, not one flow per pack (Daniel, 9 Oct).
      var pre = steps['3'] ? picks.slice() : [];
      if (steps['3']) qsa(steps['3'], 'input[type="checkbox"]:checked').forEach(function (i) { if (pre.indexOf(i.value) < 0) pre.push(i.value); });
      if (pre.length) {
        props.pack_interest = pre;
        if (!persona && pre.length === 1) props.persona = pre[0];
      }
      var attrs = { email: email, properties: props };
      if (K.sms) {
        // Texting is live in Klaviyo: subscribe the mobile to SMS as well as email.
        attrs.phone_number = e164;
        attrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } }, sms: { marketing: { consent: 'SUBSCRIBED' } } };
      }
      // Otherwise the mobile and the consent record are kept on the profile (yf_mobile, sms_*).
      subscribe(attrs, source)
        .then(function () {
          return track(K.entry, email, Object.assign({
            source: source, persona: props.persona || null, page: location.pathname,
            open_draws: open, open_count: open.length, pack_interest: props.pack_interest || [],
            hero_variant: window.YF_HERO_VARIANT || null,
            mobile: e164, consent_text: wording, sms_live_in_klaviyo: !!K.sms
          }, UTM), props, entryId + ':' + email.toLowerCase() + ':entry');
        })
        .then(function () {
          return track(K.consent, email, {
            source: source, persona: props.persona || null, page: location.pathname,
            consent_text: wording, mobile: e164, sms_live_in_klaviyo: !!K.sms
          }, record, entryId + ':' + email.toLowerCase() + ':consent');
        })
        .then(function () {
          state.email = email;
          state.mobile = true;
          var prev = parseInt(lsGet('yf_entered') || '0', 10);
          if (!prev || prev > now()) lsSet('yf_entered', String(now()));
          applyEntered(document);
          lsSet('yf_ud', JSON.stringify({ em: email.toLowerCase(), ph: e164.replace(/\D/g, '') })); // Meta Lead advanced matching: read once and removed by the Yarn First custom pixel
          publishLead(source);
          busy(f1, false);
          if (steps['3']) show('3'); else done();
        })
        .catch(function (x) {
          busy(f1, false);
          err(f1, ERR.network, input);
          if (window.console) console.warn('[Yarn First]', x);
        });
    });

    root.__yfState = state;
    // Hub: the pack-picks step after the entry.
    var f3 = steps['3'];
    if (f3) {
      f3.addEventListener('submit', function (e) {
        e.preventDefault();
        var chosen = qsa(f3, 'input[type="checkbox"]:checked').map(function (i) { return i.value; });
        busy(f3, true);
        var p = chosen.length
          ? track(K.picks, state.email, { source: source, packs: chosen },
              (!persona && chosen.length === 1) ? { pack_interest: chosen, persona: chosen[0] } : { pack_interest: chosen })
          : Promise.resolve();
        p.catch(function (x) { if (window.console) console.warn('[Yarn First]', x); })
          .then(function () { busy(f3, false); done(); });
      });
    }
    root.__yfPick = function (value) {
      if (value && picks.indexOf(value) < 0) picks.push(value);
      if (f3) { var b = qs(f3, 'input[value="' + value + '"]'); if (b) b.checked = true; }
    };
  }

  function focusJoin(pick) {
    var root = document.querySelector('[data-yf-join]');
    if (!root) return;
    if (pick && root.__yfPick) root.__yfPick(pick);
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    var f1 = qs(root, '[data-step="1"]');
    if (f1 && !f1.hidden) {
      var input = qs(f1, 'input[name="email"]');
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 350);
    }
  }

  /* ---------- Countdowns ---------- */
  function tickCountdowns() {
    var t = now();
    qsa(document, '[data-yf-cd]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-yf-cd'), 10);
      var left = end - t;
      if (left <= 0) {
        if (!el.__yfDone) {
          el.__yfDone = true;
          var msg = el.getAttribute('data-yf-cd-done');
          if (msg) el.textContent = msg;
          el.classList.add('is-closed');
        }
        return;
      }
      var m = Math.floor(left / 60);
      var d = qs(el, '[data-d]'), h = qs(el, '[data-h]'), mi = qs(el, '[data-m]');
      if (d) d.textContent = Math.floor(m / 1440);
      if (h) h.textContent = pad(Math.floor((m % 1440) / 60));
      if (mi) mi.textContent = pad(m % 60);
      var se = qs(el, '[data-s]');
      if (se) se.textContent = pad(left % 60);
    });
  }

  /* ---------- Timed refresh at switch-over times ---------- */
  // Every section of the page template, including ones hidden at render (their empty
  // wrappers are still on the page), so a section can appear at its switch-over time.
  function sectionIds() {
    return qsa(document, '[id^="shopify-section-template--"]')
      .filter(function (el) { return !el.firstElementChild || qs(el, '[data-yf-section]'); }) // Yarn First, or hidden (empty)
      .map(function (el) { return el.id.replace('shopify-section-', ''); });
  }
  function busyForm(sectionEl) {
    var sh = qs(sectionEl, '[data-yf-shop]');
    if (sh && sh.__yfDirty) return true;
    var j = qs(sectionEl, '[data-yf-join]');
    if (!j || !j.__yfState) return false;
    var s = j.__yfState;
    var f1 = qs(j, '[data-step="1"]');
    return s.dirty || (f1 && f1.hidden);
  }
  var refreshing = false;
  function fetchSections(ids) {
    var url = new URL(location.href);
    url.searchParams.set('sections', ids.join(','));
    url.searchParams.set('yfcb', String(Date.now()));
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; });
  }
  // The page's switch-over times (window.YF.next) only cover the next ~26 hours, so each
  // refresh reads them again from the join form's data-yf-next in the section responses.
  var retries = 0;
  function nextFrom(map) {
    var list = null;
    Object.keys(map).some(function (id) {
      var m = typeof map[id] === 'string' && map[id].match(/data-yf-next="([^"]*)"/);
      if (m) list = m[1].split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
      return !!m;
    });
    return list;
  }
  function refresh() {
    if (refreshing) return Promise.resolve();
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    refreshing = true;
    var batches = [];
    for (var i = 0; i < ids.length; i += 5) batches.push(ids.slice(i, i + 5)); // the API allows 5 per request
    return Promise.all(batches.map(fetchSections))
      .then(function (maps) {
        var map = Object.assign.apply(Object, [{}].concat(maps));
        ids.forEach(function (id) {
          var wrap = document.getElementById('shopify-section-' + id);
          if (!wrap || typeof map[id] !== 'string') return;
          if (busyForm(wrap)) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = map[id];
          var fresh = tmp.querySelector('#shopify-section-' + id) || tmp;
          wrap.innerHTML = fresh.innerHTML;
        });
        init(document);
        applyVariants(document);
        var list = nextFrom(map);
        if (list) {
          YF.next = list;
          // The server rendered before a switch-over this browser thinks has passed (its clock
          // runs fast): try again shortly, a few times.
          var t = now();
          if (list.some(function (e) { return e <= t; }) && retries < 6) { retries++; setTimeout(function () { refresh().then(scheduleRefresh); }, 5000); }
          else retries = 0;
        }
      })
      .catch(function () { /* try again at the next switch-over */ })
      .then(function () { refreshing = false; });
  }
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    var t = now();
    var next = (YF.next || []).filter(function (e) { return e > t; }).sort(function (a, b) { return a - b; })[0];
    if (!next) return;
    var ms = (next - t) * 1000 + 1500 + Math.floor(Math.random() * 10000); // spread open tabs over ~10s
    if (ms > 2147483647) return;
    refreshTimer = setTimeout(function () { refresh().then(scheduleRefresh); }, ms);
  }
  // A cached page can be older than a switch-over that has already passed: catch up now.
  function catchUp() {
    var t = now();
    var missed = (YF.next || []).some(function (e) { return e > (YF.now || 0) && e <= t; });
    return missed ? refresh() : Promise.resolve();
  }

  /* ---------- A/B headline (pack hero) after a refresh ---------- */
  function applyVariants(scope) {
    qsa(scope, 'script[data-yf-variants]').forEach(function (el) {
      try {
        var V = JSON.parse(el.textContent);
        var key = el.getAttribute('data-yf-variants');
        var i = parseInt(sessionStorage.getItem(key), 10);
        if (!(i >= 0 && i < V.length)) return;
        var id = el.id.replace('yf-variants-', '');
        var k = document.getElementById('yf-kicker-' + id), h = document.getElementById('yf-h-' + id);
        if (k) { k.textContent = V[i][0]; k.hidden = !V[i][0]; }
        if (h) h.textContent = V[i][1];
        window.YF_HERO_VARIANT = i + 1;
      } catch (e) { /* private mode */ }
    });
  }

  /* ---------- Share ---------- */
  function cleanUrl() {
    var u = new URL(location.href);
    return u.origin + u.pathname;
  }
  function initShare(btn) {
    if (btn.__yf) return;
    btn.__yf = true;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-share-url') || cleanUrl();
      var text = btn.getAttribute('data-share-text') || '';
      var title = btn.getAttribute('data-share-title') || document.title;
      var wrap = btn.closest('.yf-done, [data-yf-share-wrap]') || document;
      var fallback = qs(wrap, '[data-yf-share-fallback]');
      function showFallback() {
        if (!fallback) return;
        fallback.hidden = false;
        var input = qs(fallback, 'input');
        if (input) { input.value = (text ? text + ' ' : '') + url; input.select(); }
      }
      if (navigator.share) {
        navigator.share({ title: title, text: text, url: url }).catch(function () { /* cancelled */ });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText((text ? text + ' ' : '') + url)
          .then(function () { btn.textContent = 'Link copied'; })
          .catch(showFallback);
      } else {
        showFallback();
      }
    });
  }

  /* ---------- Terms popup ---------- */
  function slug(s) { return String(s).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function openTerms(anchor) {
    var dlg = document.getElementById('yf-terms-dialog');
    if (!dlg) return;
    var body = qs(dlg, '.yf-dialog-body');
    qsa(body, '.yf-target').forEach(function (el) { el.classList.remove('yf-target'); });
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    var target = null;
    if (anchor) {
      target = body.querySelector('#' + CSS.escape(anchor));
      if (!target) {
        // Match "#yf-terms-part-c", "#yf-terms-schedule-7" or "#yf-terms-the-teacher-s-pack"
        // against headings such as "Schedule 7: The Teacher's Pack". Real headings first, so
        // "part-b" lands on the Part B heading, not the "Part B:" line in the parts list.
        var match = function (sel) {
          return qsa(body, sel).filter(function (h) {
            var s = slug(h.textContent);
            return s === anchor || s.indexOf(anchor + '-') === 0 || s.slice(-anchor.length - 1) === '-' + anchor || s.indexOf('-' + anchor + '-') !== -1;
          })[0] || null;
        };
        target = match('h1,h2,h3,h4,h5') || match('strong');
      }
    }
    if (target) { target.classList.add('yf-target'); target.scrollIntoView({ block: 'start' }); } else { body.scrollTop = 0; }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#yf-terms"]');
    if (a) {
      e.preventDefault();
      var h = a.getAttribute('href').slice(1);
      openTerms(h === 'yf-terms' ? '' : h.replace(/^yf-terms-/, ''));
      return;
    }
    if (e.target.closest && e.target.closest('[data-yf-close]')) {
      var dlg = document.getElementById('yf-terms-dialog');
      if (dlg) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
      return;
    }
    var dlg2 = document.getElementById('yf-terms-dialog');
    if (dlg2 && e.target === dlg2 && dlg2.close) dlg2.close();

    var enter = e.target.closest && e.target.closest('[data-yf-enter]');
    if (enter) {
      e.preventDefault();
      focusJoin(enter.getAttribute('data-yf-enter'));
      return;
    }
    var go = e.target.closest && e.target.closest('[data-yf-goto]');
    if (go) {
      var dest = document.getElementById(go.getAttribute('data-yf-goto'));
      if (dest) { e.preventDefault(); dest.scrollIntoView({ block: 'start' }); }
    }
  });

  /* ---------- Swipe rows ---------- */
  function initSwipe(nav) {
    if (nav.__yf) return;
    nav.__yf = true;
    var row = document.getElementById(nav.getAttribute('data-yf-swipe'));
    if (!row) return;
    qsa(nav, 'button').forEach(function (b) {
      b.addEventListener('click', function () {
        row.scrollBy({ left: (+b.getAttribute('data-dir')) * row.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Sticky entry bar (pack pages, phones) ---------- */
  var stickyJoined = false, stickyObserver = null;
  document.addEventListener('yf:joined', function () {
    stickyJoined = true;
    qsa(document, '[data-yf-sticky]').forEach(function (b) { b.classList.remove('is-shown'); });
  });
  function initSticky(bar) {
    if (bar.__yf || !('IntersectionObserver' in window)) return;
    bar.__yf = true;
    var join = document.querySelector('[data-yf-join]');
    if (!join) return;
    if (stickyObserver) stickyObserver.disconnect(); // a refresh replaced the form
    stickyObserver = new IntersectionObserver(function (en) {
      bar.classList.toggle('is-shown', !en[0].isIntersecting && !stickyJoined);
    });
    stickyObserver.observe(join);
  }

  /* ---------- Shop the pack ---------- */
  function money(cents, cur) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur || 'AUD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function initShop(form) {
    if (form.__yf) return;
    form.__yf = true;
    var items = qsa(form, '[data-yf-shop-item]');
    var btn = qs(form, '[data-yf-shop-add]');
    var errEl = qs(form, '[data-yf-shop-err]');
    var doneEl = qs(form, '[data-yf-shop-done]');
    var totalEl = qs(form, '[data-yf-shop-total]');
    var label = form.getAttribute('data-label') || '[count]';
    var cur = form.getAttribute('data-currency') || 'AUD';

    function row(li) {
      var on = qs(li, '[data-yf-shop-on]');
      var v = qs(li, '[data-yf-shop-variant]');
      var isSelect = !!(v && v.tagName === 'SELECT');
      var opt = isSelect ? v.options[v.selectedIndex] : v;
      var price = opt && opt.getAttribute('data-price') ? parseInt(opt.getAttribute('data-price'), 10) : parseInt(li.getAttribute('data-min') || '0', 10);
      return { on: !!(on && on.checked && !on.disabled), id: v ? v.value : '', price: price || 0, select: isSelect ? v : null };
    }
    function update() {
      var n = 0, total = 0;
      items.forEach(function (li) {
        var s = row(li);
        li.classList.toggle('is-off', !s.on);
        var pr = qs(li, '[data-yf-shop-price]');
        if (pr && s.id && s.price) pr.textContent = money(s.price, cur);
        if (s.on) { n++; total += s.price; }
      });
      if (totalEl) totalEl.textContent = money(total, cur);
      if (btn) {
        btn.textContent = label.replace('[count]', n ? String(n) : '').replace(/\s+/g, ' ').trim();
        btn.disabled = !n;
      }
    }
    function fail(msg, el) {
      if (errEl) errEl.textContent = msg || '';
      if (el && msg) el.focus();
    }

    form.addEventListener('change', function () {
      form.__yfDirty = true;
      fail('');
      if (doneEl) doneEl.hidden = true;
      update();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var lines = [], missing = null;
      items.forEach(function (li) {
        var s = row(li);
        if (!s.on) return;
        if (!s.id) { if (!missing) missing = { li: li, el: s.select }; return; }
        lines.push({ id: parseInt(s.id, 10), quantity: 1 });
      });
      if (missing) { fail((form.getAttribute('data-err-size') || '').replace('[item]', missing.li.getAttribute('data-name') || ''), missing.el); return; }
      if (!lines.length) { fail(form.getAttribute('data-err-none')); return; }
      fail('');
      if (btn) btn.disabled = true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || '');
            return d;
          });
        })
        .then(function (d) {
          if (doneEl) doneEl.hidden = false;
          // The same events as the theme's Quick Add: the Rebuy cart opens itself on the
          // /cart/add.js call, and these refresh the cart count. Never call SmartCart.show()
          // (see snippets/pdp-rebuy-atc.liquid).
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('quickadd:added', { detail: { variantId: lines[0].id, items: d.items || [] } }));
          if (typeof window.updateCart === 'function') { try { window.updateCart(); } catch (x) { /* theme */ } }
        })
        .catch(function (x) {
          fail((x && x.message) || form.getAttribute('data-err-add'));
          if (window.console) console.warn('[Yarn First]', x);
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          update();
        });
    });
    update();
  }

  /* ---------- Entered / not entered variants ---------- */
  // 'You're entered' markers: anything carrying data-yf-until whose entries were still
  // open when this browser first entered (entry = Klaviyo accepted the email step).
  // Per browser only, from localStorage.
  function applyEntered(scope) {
    var at = parseInt(lsGet('yf_entered') || '0', 10);
    var entered = !!at;
    qsa(scope, '[data-yf-until]').forEach(function (el) {
      var close = parseInt(el.getAttribute('data-yf-until'), 10);
      var on = entered && at < close;
      var holder = el.matches('.yf-entered') ? el.parentNode : el;
      holder.classList.toggle('is-entered', on);
      qsa(holder, '.yf-entered').forEach(function (b) { b.hidden = !on; });
    });
    qsa(scope, '[data-yf-if-entered]').forEach(function (el) { el.hidden = !entered; });
    qsa(scope, '[data-yf-if-not-entered]').forEach(function (el) { el.hidden = entered; });
  }

  function init(scope) {
    qsa(scope, '[data-yf-join]').forEach(initJoin);
    qsa(scope, '[data-yf-share]').forEach(initShare);
    qsa(scope, '[data-yf-swipe]').forEach(initSwipe);
    qsa(scope, '[data-yf-sticky]').forEach(initSticky);
    qsa(scope, '[data-yf-shop]').forEach(initShop);
    applyEntered(scope);
    tickCountdowns();
  }

  function boot() {
    // ?yf_reset=1 clears this browser's "You're in" marker and saved UTMs (for testing),
    // then tidies the address bar.
    try {
      var u = new URL(location.href);
      if (u.searchParams.has('yf_reset')) {
        try { localStorage.removeItem('yf_entered'); sessionStorage.removeItem('yf_utm'); } catch (e) { /* private mode */ }
        u.searchParams.delete('yf_reset');
        history.replaceState(null, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash);
      }
    } catch (e) { /* old browser */ }
    init(document);
    setInterval(tickCountdowns, 20000);
    catchUp().then(scheduleRefresh);
    // Second-by-second only while a countdown with seconds is on the page (Tonight Only).
    setInterval(function () { if (document.querySelector('[data-yf-cd] [data-s]')) tickCountdowns(); }, 1000);
    document.addEventListener('yf:joined', function () { applyEntered(document); });
    if (location.hash && location.hash.indexOf('#yf-terms') === 0) {
      var h = location.hash.slice(1);
      openTerms(h === 'yf-terms' ? '' : h.replace(/^yf-terms-/, ''));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
